import { printerModelsClient } from './clients';
import { authMetadata } from './metadata';
import { grpcCall } from './errors';
import {
    buildCreatePrinterModelRequest,
    buildListPrinterModelsRequest,
    buildUpdatePrinterModelRequest,
} from './requestBuilders';
import {
    deleteResponseFromProto,
    maintenanceTaskTypeFromProto,
    printerModelFromProto,
    printerModelsListResponseFromProto,
} from './restMappers';

export function isPublicFarmLinkSupportQuery(value) {
    return ['yes', 'true', '1', 'implemented'].includes(String(value || '').trim().toLowerCase());
}

export async function listPrinterModels(query = {}) {
    const req = buildListPrinterModelsRequest(query);
    const res = await grpcCall(printerModelsClient().listPrinterModels(req, {}));
    return printerModelsListResponseFromProto(res);
}

export async function getPrinterModel(uuid) {
    const { GetPrinterModelRequest } = require('./proto/acompanha/printer_models/v1/printer_models_pb');
    const req = new GetPrinterModelRequest();
    req.setUuid(String(uuid || ''));
    const res = await grpcCall(printerModelsClient().getPrinterModel(req, authMetadata()));
    return printerModelFromProto(res.getData());
}

export async function createPrinterModel(data) {
    const req = buildCreatePrinterModelRequest(data);
    const res = await grpcCall(printerModelsClient().createPrinterModel(req, authMetadata()));
    return printerModelFromProto(res.getData());
}

export async function updatePrinterModel(uuid, data) {
    const req = buildUpdatePrinterModelRequest(uuid, data);
    const res = await grpcCall(printerModelsClient().updatePrinterModel(req, authMetadata()));
    return printerModelFromProto(res.getData());
}

export async function deletePrinterModel(uuid) {
    const { DeletePrinterModelRequest } = require('./proto/acompanha/printer_models/v1/printer_models_pb');
    const req = new DeletePrinterModelRequest();
    req.setUuid(String(uuid || ''));
    const res = await grpcCall(printerModelsClient().deletePrinterModel(req, authMetadata()));
    return deleteResponseFromProto(res);
}

export async function listMaintenanceTaskTypes() {
    const { ListMaintenanceTaskTypesRequest } = require('./proto/acompanha/printer_models/v1/printer_models_pb');
    const req = new ListMaintenanceTaskTypesRequest();
    const res = await grpcCall(printerModelsClient().listMaintenanceTaskTypes(req, authMetadata()));
    return (res.getItemsList() || []).map(maintenanceTaskTypeFromProto).filter(Boolean);
}

export async function listFarmLinkSupportedPrinterModels(limit = 500) {
    return listPrinterModels({
        page: 1,
        limit,
        farm_link_support: 'yes',
    });
}
